import { Box, Center, Spinner } from '@chakra-ui/react';
import { FC } from 'react';
import { useFetchChatListQuery } from 'rtkQuery/sharespro/queries/chat';

import ChatListLoaded from 'presentation/components/modules/chat/list/ChatList';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import { widgetChatSlice } from 'slices/modules/chat/widgetChatSlice';
import useAppDispatch from 'hooks/shared/store/useAppDispatch';
import { useInterval } from 'react-use';

interface Props {
  page: number;
  setPage: (page: number) => void;
}

const ChatListWidgetContainer: FC<Props> = ({ page, setPage }) => {
  const { isFetching, data, error, refetch } = useFetchChatListQuery({ page });

  useInterval(() => {
    refetch();
  }, 5000);

  const dispatch = useAppDispatch();

  if (data) {
    return (
      <ChatListLoaded
        items={data.chats.items}
        pageCount={data.chats.pageCount}
        currentPage={data.chats.currentPage}
        setPage={setPage}
        isFetching={isFetching}
        onItemSelected={(item) =>
          dispatch(
            widgetChatSlice.actions.setChat({
              name: item.name,
              id: item.id,
              type: item.type,
            })
          )
        }
      />
    );
  }

  let content;
  if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <Box p={3}>
        <ErrorContainer
          error={error}
          onRetry={() => {
            refetch();
          }}
        />
      </Box>
    );
  } else {
    content = <Spinner />;
  }

  return (
    <Center p="20px" h="100%" w="100%">
      {content}
    </Center>
  );
};

export default ChatListWidgetContainer;
